import React,{useState,useEffect} from 'react'
import { URL } from '../../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { invokeDisclaimer } from '../../ServiceCalls/ApiCalls';
import { PropagateLoader } from 'react-spinners';
import './disclaimer.css'

function DisclaimerComponent() {

    const navigate = useNavigate()

    const[disclaimers,setDisclaimers] = useState([])
    const[disclaimer,setDisclaimer] = useState('')
    const[disclaimerid,setDisclaimerId] = useState('')
    const[rowid,setRowId]= useState('')
    const[createDisclaimer,setCreateDisclaimer] = useState({
        disclaimer:'',
    })
    const[status,setStatus]=useState(false)
    const[isLoading,setIsLoading]=useState(false)
    const[isRefreshing,setIsRefreshing]=useState(false)

    useEffect(() =>{
        if(!localStorage.getItem('user')){
            navigate('/')
        }
        async function GetData(){
            setIsLoading(true)
            try {
                const disclaimer_list = await invokeDisclaimer()
                setDisclaimers([...disclaimer_list])
            } catch (error) {
                console.error('Error fetching disclaimers:', error)
                toast.error('Failed to load disclaimers')
            } finally {
                setIsLoading(false)
            }
        }
    
        GetData()
    },[])

    const handleAddDisclaimer = (e) => {
        const{name,value} = e.target;
        setCreateDisclaimer({...createDisclaimer,[name]:value})
    }

    const options = (method = "GET",body) =>{
        return {
            method,
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(body)
        }
    }

    const handleSubmitDisclaimer = async(e) => {

        e.preventDefault()

        try {
            const add_disclaimer_response = await fetch(`${URL}` + '/disclaimer/adddisclaimer',options("POST",createDisclaimer));
            
            if(add_disclaimer_response.ok){
                const disclaimer_data = await add_disclaimer_response.json();
                setDisclaimers(prev =>[...prev,disclaimer_data])
                toast.success('🦄 Wow Disclaimer Added!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                reset()
            }
            else{
                //alert('Add TermDates Failed...')
                toast.error('🦄 OOps Add Disclaimer Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleDisclaimerChange = e =>{
        const{name,value} = e.target;

        if(name === 'disclaimer'){
            setDisclaimer(value)
        }
    }
    const reset = (e) => {
        e.preventDefault()
        setCreateDisclaimer({
            disclaimer:''
        })
    }

    const refreshDisclaimers = async () => {
        setIsRefreshing(true)
        try {
            const disclaimer_list = await invokeDisclaimer()
            setDisclaimers([...disclaimer_list])
            toast.success('Disclaimers refreshed successfully!')
        } catch (error) {
            console.error('Error refreshing disclaimers:', error)
            toast.error('Failed to refresh disclaimers')
        } finally {
            setIsRefreshing(false)
        }
    }
    const handleUpdateDisclaimer = async() => {
        try {
            const update_disclaimer_response = await fetch(`${URL}` + '/disclaimer/'+`${disclaimerid}`,options("PATCH",{disclaimer}));

            if(update_disclaimer_response.ok){
                const update_disclaimer_status = await update_disclaimer_response.json();
                const dataUpdate = [...disclaimers]
                dataUpdate[rowid] = update_disclaimer_status;
                setDisclaimers([...dataUpdate])
                setStatus(true)
                //toggleRow(rowid)
                toast.success('🦄 Wow Row Updated!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
            }
            else{
               // alert('Update Failed')
               toast.error('🦄 OOps Update Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
    
        } catch (error) {
            console.log(error)
        }
    }
    const handleEditDisclaimer = (d,rid) => {
        setDisclaimer(d.disclaimer)
        setDisclaimerId(d._id)
        setRowId(rid)
        setStatus(false)
    }
    const deleteDisclaimer = async(tr_id,rowid) => {

        if(!window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rowid+1}`))
            return;

        try{
            const delete_disclaimer_response = await fetch(`${URL}` + '/disclaimer/'+`${tr_id}`, options("DELETE"));
            if(delete_disclaimer_response.ok){
               // alert(`TermDate at ${rowid+1}  is Deleted !!`)
                const dataDelete = [...disclaimers];
                dataDelete.splice(rowid,1)
                setDisclaimers([...dataDelete])
                toast.success('🦄 Wow Disclaimer Deleted!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
    
            }
            else{
                toast.error('🦄 OOps Disclaimer Del Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        }catch(err){
            console.log(err)
        }
    }

  return (
    <div className='admin-panel'>
      <div className="container admin-container">
        {/* Header Section */}
        <div className="row mt-5">
          <div className="col-md-12">
            <div className="failed-bookings-header d-flex justify-content-between align-items-center mb-4">
              <div>
                <h3 className="mb-1">
                  <i className="fa fa-file-text text-warning me-2"></i>
                  Manage Disclaimers
                </h3>
                <p className="text-muted">
                  Add and manage disclaimer statements for your badminton facility
                </p>
                <span className="badge bg-primary">
                  <i className="fa fa-file-text me-1"></i>
                  {disclaimers.length} {disclaimers.length === 1 ? 'Disclaimer' : 'Disclaimers'}
                </span>
              </div>
              <div className="header-actions">
                <button
                  onClick={refreshDisclaimers}
                  disabled={isRefreshing}
                  className="btn btn-outline-primary me-2">
                  {isRefreshing ? (
                    <PropagateLoader size={8} color="#007bff" />
                  ) : (
                    <>
                      <i className="fa fa-refresh me-2"></i>
                      Refresh
                    </>
                  )}
                </button>
                <button
                  onClick={() => navigate('/user')}
                  className="btn btn-outline-secondary">
                  <i className="fa fa-arrow-left me-2"></i>
                  Back to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Loading State */}
        {isLoading ? (
          <div className="loading-container">
            <div className="loading-content">
              <PropagateLoader size={15} color="#007bff" />
              <p className="loading-text">Loading disclaimers...</p>
            </div>
          </div>
        ) : (
          <>
            {/* Add Disclaimer Section */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="admin-section">
                  <div className="section-header">
                    <h5 className="section-title">
                      <i className="fa fa-plus text-success me-2"></i>
                      Add New Disclaimer
                    </h5>
                  </div>
                  <form onSubmit={handleSubmitDisclaimer} className="disclaimer-form">
                    <div className="row">
                      <div className="col-12 mb-3">
                        <label htmlFor="disclaimer" className="form-label">
                          <i className="fa fa-file-text text-info me-2"></i>
                          Disclaimer Statement
                        </label>
                        <textarea
                          className="form-control"
                          id="disclaimer"
                          name="disclaimer"
                          rows={6}
                          value={createDisclaimer.disclaimer}
                          onChange={e => handleAddDisclaimer(e)}
                          required
                          placeholder="Enter disclaimer statement (e.g., liability waivers, terms of use, safety guidelines)"
                          autoComplete='off' />
                      </div>
                    </div>
                    <div className="form-actions">
                      <button 
                        type="submit" 
                        className="btn btn-primary me-2">
                        <i className="fa fa-plus me-2"></i>
                        Add Disclaimer
                      </button>
                      <button 
                        type="button"
                        onClick={e => reset(e)}
                        className="btn btn-outline-secondary">
                        <i className="fa fa-refresh me-2"></i>
                        Reset Form
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Existing Disclaimers Section */}
            <div className="row">
              <div className="col-12">
                <div className="admin-section">
                  <div className="section-header">
                    <h5 className="section-title">
                      <i className="fa fa-list text-info me-2"></i>
                      Existing Disclaimers
                    </h5>
                  </div>
                  <div className="table-responsive">
                    <table className='table table-bordered table-hover'>
                        <thead className="table-warning text-center">
                            <tr>
                                <th>S.No</th>
                                <th>Disclaimer Statement</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {disclaimers.length > 0 ? (
                                disclaimers.map((d, idx) => (
                                  <tr key={idx}>
                                    <td className="text-center">{idx + 1}</td>
                                    <td>
                                      <div className="disclaimer-text">
                                        {d.disclaimer.length > 100 ? (
                                          <>
                                            <span>{d.disclaimer.substring(0, 100)}...</span>
                                            <small className="text-muted d-block">
                                              <i className="fa fa-info-circle me-1"></i>
                                              Full text: {d.disclaimer.length} characters
                                            </small>
                                          </>
                                        ) : (
                                          <span>{d.disclaimer}</span>
                                        )}
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <div className="btn-group" role="group">
                                        <button
                                          type="button"
                                          onClick={() => handleEditDisclaimer(d, idx)}
                                          data-bs-toggle="modal"
                                          data-bs-target="#editModalPop"
                                          className="btn btn-sm btn-outline-primary"
                                          title="Edit Disclaimer">
                                          <i className="fa fa-edit"></i>
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() => deleteDisclaimer(d._id,idx)}
                                          className="btn btn-sm btn-outline-danger"
                                          title="Delete Disclaimer">
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={3} className="text-center py-4">
                                    <div className="empty-state">
                                      <i className="fa fa-file-text fa-3x text-muted mb-3"></i>
                                      <h5 className="text-muted">No Disclaimers Found</h5>
                                      <p className="text-muted">Add your first disclaimer statement using the form above.</p>
                                    </div>
                                  </td>
                                </tr>
                              )
                            }
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Edit Modal */}
        <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="editModalPop">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">Edit Disclaimer</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close">
                </button>
              </div>
              <div className="modal-body">
                {status ? (
                  <div className="container">
                    <div className="row my-3">
                      <div className="col-md-12 col-sm-12 d-flex flex-column justify-content-center border-1">
                        <div className="success-img"></div>
                        <h4 className="text-success text-center m-3">Row Updated Successfully !!!</h4>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="container">
                    <div className="row my-3">
                      <div className="col-md-12 col-sm-12">
                        <label htmlFor="disclaimer" className="small"><strong>Disclaimer</strong></label>
                        <textarea
                          type="text"
                          className='form-control service'
                          name="disclaimer"
                          value={disclaimer}
                          rows={3}
                          onChange={e => handleDisclaimerChange(e)}
                          autoComplete='off'
                          id="disclaimer" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                {status ? (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal">
                    Close
                  </button>
                ) : (
                  <button
                    onClick={() => handleUpdateDisclaimer()}
                    type="button"
                    className="btn btn-primary">
                    Update
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default DisclaimerComponent